/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { DataSplittingModes } from 'src/modules/modelTraining/types/trainingTypes';

export type PerformanceMetricsBreakdown = {
    name: string;
    precision: number;
    recall: number;
    f1Score: number;
    truePositiveCount?: number;
    trueNegativeCount?: number;
    falsePositiveCount?: number;
    falseNegativeCount?: number;
};

export class ModelEvaluationStore {
    public readonly recall: number;

    public readonly f1Score: number;

    public readonly precision: number;

    public readonly confusionMatrix: number[][];

    public readonly trainingSplitType: DataSplittingModes;

    public readonly normalizedConfusionMatrix: number[][];

    public readonly performanceMetricsBreakdown: PerformanceMetricsBreakdown[];

    public readonly testingSplitPercentage: string;

    constructor(modelData: Partial<ModelEvaluationStore>) {
        this.recall = modelData.recall;
        this.f1Score = modelData.f1Score;
        this.precision = modelData.precision;
        this.confusionMatrix = modelData.confusionMatrix;
        this.trainingSplitType = modelData.trainingSplitType;
        this.normalizedConfusionMatrix = modelData.normalizedConfusionMatrix;
        this.performanceMetricsBreakdown = modelData.performanceMetricsBreakdown;
        this.testingSplitPercentage = modelData.testingSplitPercentage;
    }
}
